import { Icon } from './chunk-3QHO3DXX.js';
import { TooltipController } from './chunk-BSU4PWFL.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { setAttributeIfEmpty, setARIALabel, onPress } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { $$_create_component } from 'maverick.js/dom';
import { defineElement, Component } from 'maverick.js/element';
import { seekBackwardPaths, seekForwardPaths } from 'media-icons';

var SeekButton = class extends Component {
  constructor(instance) {
    super(instance);
    this.a = useMedia();
    new FocusVisibleController(instance);
    new TooltipController(instance);
  }
  onAttach(el) {
    setAttributeIfEmpty(el, "tabindex", "0");
    setAttributeIfEmpty(el, "role", "button");
    setARIALabel(el, this.F.bind(this));
    const { seconds, defaultAppearance } = this.$props;
    this.setAttributes({
      seconds,
      "default-appearance": defaultAppearance,
      "aria-hidden": $ariaBool(this.v.bind(this)),
      "data-media-button": true
    });
  }
  onConnect(el) {
    onPress(el, this.G.bind(this));
  }
  v() {
    const { canSeek } = this.a.$store;
    return !canSeek();
  }
  F() {
    const { seconds } = this.$props;
    return `Seek ${seconds() > 0 ? "forward" : "backward"} ${seconds()} seconds`;
  }
  G(event) {
    const { seconds, disabled } = this.$props;
    if (disabled())
      return;
    const { currentTime } = this.a.$store, seekTo = currentTime() + seconds();
    this.a.remote.seek(seekTo, event);
  }
  render() {
    return [
      $$_create_component(Icon, { paths: seekBackwardPaths, slot: "backward" }),
      $$_create_component(Icon, { paths: seekForwardPaths, slot: "forward" })
    ];
  }
};
SeekButton.el = defineElement({
  tagName: "media-seek-button",
  props: {
    disabled: false,
    defaultAppearance: false,
    seconds: 30
  }
});

export { SeekButton };
